import animationRandom from './json/Animation-random.json'
import animationCard from './json/Animation-card.json'
import animationLoadout from './json/Animation-loadout.json'
import animationLoading from './json/Animation-loading.json'

export const lottieSet: Record<string, any> = {
  'animation-random': animationRandom,
  'animation-card': animationCard,
  'animation-loadout': animationLoadout,
  'animation-loading': animationLoading,
}
